import { Button, Input, InputNumber, Modal } from "antd";
import { Guess } from "../../types/Guess";
import { useEffect, useState } from "react";
import { UserOutlined, SlidersOutlined } from '@ant-design/icons';


interface EditGuessModalProps {
  guess: Guess | undefined;
  open: boolean;
  setOpen: any;
  editGuess: any;
}

function EditGuessModal({ guess, open, setOpen, editGuess }: EditGuessModalProps) {

  useEffect(() => {
    setEditedName(guess?.name ?? '');
    setEditedValue(guess?.value ?? 0)
  }, [guess]);

  const [editedName, setEditedName] = useState<string>(guess?.name ?? '');
  const [editedValue, setEditedValue] = useState<number>(guess?.value ?? 0);

  const handleOk = () => {
    setOpen(false);
    editGuess(guess, editedName, editedValue);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <Modal
      centered
      title="Schätzung bearbeiten"
      open={open}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={[
        <Button key="back" onClick={handleCancel} size="large">
          Abbrechen
        </Button>,
        <Button key="submit" type="primary" onClick={handleOk} size="large">
          Speichern
        </Button>
      ]}
    >
      <Input className="guessInput" size="large" placeholder="Name" prefix={<UserOutlined />} value={editedName} onChange={(e) => setEditedName(e.target.value)} />
      <br />
      <InputNumber prefix={<SlidersOutlined />} className="guessInput" size="large" placeholder="Schätzung" value={editedValue}
        onChange={(num) => setEditedValue(num ?? 0)}
      />
    </Modal>
  )
}

export default EditGuessModal;